import { render } from "./TextDisplay.vue?vue&type=template&id=82c0d5ea&scoped=true"
import script from "./TextDisplay.vue?vue&type=script&lang=js"
export * from "./TextDisplay.vue?vue&type=script&lang=js"

import "./TextDisplay.vue?vue&type=style&index=0&id=82c0d5ea&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c0d5ea"]])

export default __exports__